// Summary Store

const state = {
  summary: {},
  coinPacksOnly: false,
  pending: false,
  // error: null,
}

const getters = {
  isPending: ({ pending }) => pending,
}

const actions = {
  getSummary({ commit }) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      this.api.items.getItems('carts.mine').then(({ data }) => {
        commit('SET_SUMMARY', data.cart.summary)
        commit('SET_COIN_PACKS_ONLY', data.coin_packs_only)
        commit('cart/SET_MIN_ORDER_VALUE', data.min_order_value, { root: true })
        commit('SET_PENDING')
        resolve()
      })
    })
  },
  removeItem({ commit, dispatch }, id) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      this.api.items.deleteItem(`carts.mine.items.${id}`)
      .then(_ => {
        dispatch('getSummary')
        commit('LAST_REMOVE_PRODUCT')
        commit('SET_PENDING')
        resolve()
      })
    })
  },
  getProductOptions({ commit }, id) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      this.api.items.getItem(`carts.mine.items.${id}.options`)
      .then(({ data }) => {
        commit('SET_PENDING')
        resolve(data)
      })
    })
  },
  updateCartItemOption({ commit, dispatch }, { id, option }) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      this.api.items.editItem(`carts.mine.items.${id}`, option)
      .then(({ data }) => {
        commit('SET_PENDING')
        dispatch('getSummary')
        resolve(data)
      })
    })
  },
}

const mutations = {
  SET_PENDING: state => {
    state.pending = !state.pending
  },
  // SET_ERROR: (state, payload) => {
  //   state.error = payload
  // },
  SET_SUMMARY: (state, payload) => {
    state.summary = payload
  },
  SET_COIN_PACKS_ONLY: (state, payload) => {
    state.coinPacksOnly = payload
  },
  LAST_REMOVE_PRODUCT: _ => {
    return true
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
